import { render, staticRenderFns } from "./WorkspaceProjectsList.vue?vue&type=template&id=6f66bf28&"
import script from "./WorkspaceProjectsList.vue?vue&type=script&lang=js&"
export * from "./WorkspaceProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports